import { store } from '@/store/store'
import Layout from '@/container/Full'
const SslCertificates = () => import(/* webpackChunkName: "ssl" */ '@/views/security/SslCertificates')
const SslOverview = () => import(/* webpackChunkName: "ssl" */ '@/views/security/SslOverview')
const SslCreate = () => import(/* webpackChunkName: "ssl" */ '@/views/security/SslCreate')

const routes = [
  {
    path: '/ssl',
    component: Layout,
    meta: {
      breadcrumb: 'Security',
      pageTitle: 'Security',
    },
    children: [
      {
        path: '/',
        name: 'ssl_list',
        component: SslCertificates,
        meta: {
          breadcrumb: 'SSL',
          pageTitle: 'Security',
          access_type: 'authorized'
        },
      },
      {
        path: '/ssl/add',
        name: 'ssl_create',
        component: SslCreate,
        meta: {
          breadcrumb: 'Add SSL Certificate',
          pageTitle: 'Add SSL Certificate',
          access_type: 'authorized'
        },
      },
      {
        path: '/ssl/:id',
        name: 'ssl_overview',
        component: SslOverview,
        props: true,
        meta: {
          breadcrumb: () => store.getters?.ssl?.domain,
          pageTitle: 'Security',
          access_type: 'authorized'
        },
      },
    ]
  },
]

export default routes
